import type { FormEvent } from 'react';
import { Button } from '@shared/ui/Button';
import {
  ButtonGroup,
  FormBox,
  FormGrid,
  FormTitle,
  Input,
} from './styles';

interface AddInflowPlanModalProps {
  projectName: string;
  setProjectName: (v: string) => void;
  customerName: string;
  setCustomerName: (v: string) => void;
  contractNo: string;
  setContractNo: (v: string) => void;
  expectedDate: string;
  setExpectedDate: (v: string) => void;
  bddsPlanned: string;
  setBddsPlanned: (v: string) => void;
  ks3Signed: string;
  setKs3Signed: (v: string) => void;
  ks3DocNo: string;
  setKs3DocNo: (v: string) => void;
  advanceDed: string;
  setAdvanceDed: (v: string) => void;
  retentionDed: string;
  setRetentionDed: (v: string) => void;
  actualReceived: string;
  setActualReceived: (v: string) => void;
  responsible: string;
  setResponsible: (v: string) => void;
  isCreating: boolean;
  onSubmit: (e: FormEvent) => void;
  onClose: () => void;
}

export function AddInflowPlanModal({
  projectName,
  setProjectName,
  customerName,
  setCustomerName,
  contractNo,
  setContractNo,
  expectedDate,
  setExpectedDate,
  bddsPlanned,
  setBddsPlanned,
  ks3Signed,
  setKs3Signed,
  ks3DocNo,
  setKs3DocNo,
  advanceDed,
  setAdvanceDed,
  retentionDed,
  setRetentionDed,
  actualReceived,
  setActualReceived,
  responsible,
  setResponsible,
  isCreating,
  onSubmit,
  onClose,
}: AddInflowPlanModalProps) {
  return (
    <FormBox as="form" onSubmit={onSubmit}>
      <FormTitle>Добавление позиции плана поступлений БДДС и подписанной КС-3</FormTitle>
      <FormGrid>
        <Input
          placeholder="Строительный объект"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
          required
        />
        <Input
          placeholder="Заказчик"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          required
        />
        <Input
          placeholder="№ договора подряда"
          value={contractNo}
          onChange={(e) => setContractNo(e.target.value)}
        />
        <Input
          type="date"
          value={expectedDate}
          onChange={(e) => setExpectedDate(e.target.value)}
        />
        <Input
          type="number"
          placeholder="План по БДДС, ₽"
          value={bddsPlanned}
          onChange={(e) => setBddsPlanned(e.target.value)}
          required
        />
        <Input
          type="number"
          placeholder="Подписано по КС-3 (брутто), ₽"
          value={ks3Signed}
          onChange={(e) => setKs3Signed(e.target.value)}
        />
        <Input
          placeholder="№ справки КС-3 (напр. КС-3 № 15)"
          value={ks3DocNo}
          onChange={(e) => setKs3DocNo(e.target.value)}
        />
        <Input
          type="number"
          placeholder="Зачёт аванса по КС-3, ₽"
          value={advanceDed}
          onChange={(e) => setAdvanceDed(e.target.value)}
        />
        <Input
          type="number"
          placeholder="Гарантийное удержание (ГУ), ₽"
          value={retentionDed}
          onChange={(e) => setRetentionDed(e.target.value)}
        />
        <Input
          type="number"
          placeholder="Фактически поступило на р/с, ₽"
          value={actualReceived}
          onChange={(e) => setActualReceived(e.target.value)}
        />
        <Input
          placeholder="Ответственный РП"
          value={responsible}
          onChange={(e) => setResponsible(e.target.value)}
        />
      </FormGrid>
      <ButtonGroup>
        <Button $size="sm" type="submit" disabled={isCreating}>
          Сохранить позицию
        </Button>
        <Button
          $size="sm"
          $variant="ghost"
          type="button"
          onClick={onClose}
        >
          Отмена
        </Button>
      </ButtonGroup>
    </FormBox>
  );
}
